const shifts = {
  permissionSource: 'api::shift-pattern.shift-pattern',
  creationTitle: 'Create Shift',
  creationEndPoint: '/shift-patterns',
  detailTitle: 'Shift: :title',
  detailEndPoint: '/shift-patterns/:id',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Name',
          value: 'name',
          tag: 'input',
          type: 'text',
          placeholder: 'Name',
          required: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Start time',
          value: 'start_time',
          tag: 'datetime-picker',
          type: 'text',
        },
        {
          label: 'End time',
          value: 'end_time',
          tag: 'datetime-picker',
          type: 'text',
        },
      ],
    },
    {
      label: 'Duration',
      value: 'duration',
      tag: 'input',
      type: 'number',
      placeholder: 'Duration',
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Type',
          value: 'type',
          tag: 'single-enum-select',
          dataSourceUrl: '/content-type-builder/content-types/api::shift-pattern.shift-pattern',
          dataLabel: 'type',
        },
        {
          label: 'Cycle',
          value: 'cycle',
          tag: 'single-enum-select',
          dataSourceUrl: '/content-type-builder/content-types/api::shift-pattern.shift-pattern',
          dataLabel: 'cycle',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Pattern',
          value: 'patter',
          tag: 'input',
          type: 'text',
          placeholder: 'Pattern',
        },
        {
          label: 'Remark',
          value: 'remark',
          tag: 'input',
          type: 'text',
          placeholder: 'Remark',
        },
      ],
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
  },
}
export default shifts
